export type PrimitiveDataType = string | boolean | number;

export const enum PageSize {
  ONE = 1,
  TWO = 2,
  FIVE = 5,
  TEN = 10,
  FIFTEEN = 15,
  TWENTY = 20,
  TWENTY_FIVE = 25,
  FIFTY = 50,
  HUNDRED = 100,
}

export const PageSizes = [
  PageSize.ONE,
  PageSize.TWO,
  PageSize.FIVE,
  PageSize.TEN,
  PageSize.FIFTEEN,
  PageSize.TWENTY,
  PageSize.TWENTY_FIVE,
  PageSize.FIFTY,
  PageSize.HUNDRED,
];

export type FileUploaded = {
  filePath: string;
  fileId: string;
  fileUrl: string;
  fileType: string;
  fileSize: string;
};
export interface IconProps {
  color?: string;
  size?: string | number;
  fillColor?: string;
}

export interface PageData {
  page?: number;
  pageSize?: PageSize;
  totalPages?: number;
  totalData?: number;
}

export const enum CropType {
  CIRCLE = "CIRCLE",
  SQUARE = "SQAURE",
}
export interface UserSpecificPageData {
  totalAdmins: number;
}
export const enum DayNight {
  AM = "AM",
  PM = "PM",
}
export const enum TimeFormat {
  Twelve = "12",
  TwentyFour = "24",
}

export type UIPlacement = "top" | "bottom" | "left" | "right";

export type EmailSuggestion = {
  id: string;
  value: string;
};
